/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  AccountId,
  FilterUnitRegistrationId,
  FilterUnitRegistrationRequest,
  FilterUnitRegistrationResponse,
  FilterUnitRegistrationUpdateRequest,
  HttpValidationProblemDetails,
  MoveFilterUnitRequest,
  RegistrationCompositeId,
  SegmentationId
} from './data.schemas'




export const createFilterRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    filterUnitRegistrationRequest: FilterUnitRegistrationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FilterUnitRegistrationId>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/filter-units`,
      filterUnitRegistrationRequest,options
    );
  }



export const getCreateFilterRegistrationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: FilterUnitRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: FilterUnitRegistrationRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFilterRegistration>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: FilterUnitRegistrationRequest}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,data} = props ?? {};

          return  createFilterRegistration(segmentationId,accountId,registrationCompositeId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFilterRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof createFilterRegistration>>>
    export type CreateFilterRegistrationMutationBody = FilterUnitRegistrationRequest
    export type CreateFilterRegistrationMutationError = AxiosError<HttpValidationProblemDetails | string>

    export const useCreateFilterRegistration = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: FilterUnitRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createFilterRegistration>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: FilterUnitRegistrationRequest},
        TContext
      > => {

      const mutationOptions = getCreateFilterRegistrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getFilterRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    filterUnitId: FilterUnitRegistrationId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FilterUnitRegistrationResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/filter-units/${encodeURIComponent(String(filterUnitId))}`,options
    );
  }


export const getGetFilterRegistrationQueryKey = (segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    filterUnitId: FilterUnitRegistrationId,) => {
    return [`/api/segment/${segmentationId}/customers/${accountId}/registrationComposites/${registrationCompositeId}/filter-units/${filterUnitId}`] as const;
    }

    
export const getGetFilterRegistrationQueryOptions = <TData = Awaited<ReturnType<typeof getFilterRegistration>>, TError = AxiosError<string>>(segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    filterUnitId: FilterUnitRegistrationId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterRegistration>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFilterRegistrationQueryKey(segmentationId,accountId,registrationCompositeId,filterUnitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFilterRegistration>>> = ({ signal }) => getFilterRegistration(segmentationId,accountId,registrationCompositeId,filterUnitId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId && accountId && registrationCompositeId && filterUnitId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFilterRegistration>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFilterRegistrationQueryResult = NonNullable<Awaited<ReturnType<typeof getFilterRegistration>>>
export type GetFilterRegistrationQueryError = AxiosError<string>

export const useGetFilterRegistration = <TData = Awaited<ReturnType<typeof getFilterRegistration>>, TError = AxiosError<string>>(
 segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    filterUnitId: FilterUnitRegistrationId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterRegistration>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFilterRegistrationQueryOptions(segmentationId,accountId,registrationCompositeId,filterUnitId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetFilterRegistration = async <TData = Awaited<ReturnType<typeof getFilterRegistration>>, TError = AxiosError<string>>(
 queryClient: QueryClient, segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    filterUnitId: FilterUnitRegistrationId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterRegistration>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getGetFilterRegistrationQueryOptions(segmentationId,accountId,registrationCompositeId,filterUnitId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const updateFilterRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    filterUnitId: FilterUnitRegistrationId,
    filterUnitRegistrationUpdateRequest: FilterUnitRegistrationUpdateRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.put(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/filter-units/${encodeURIComponent(String(filterUnitId))}`,
      filterUnitRegistrationUpdateRequest,options
    );
  }



export const getUpdateFilterRegistrationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: FilterUnitRegistrationUpdateRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: FilterUnitRegistrationUpdateRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFilterRegistration>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: FilterUnitRegistrationUpdateRequest}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,filterUnitId,data} = props ?? {};

          return  updateFilterRegistration(segmentationId,accountId,registrationCompositeId,filterUnitId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFilterRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof updateFilterRegistration>>>
    export type UpdateFilterRegistrationMutationBody = FilterUnitRegistrationUpdateRequest
    export type UpdateFilterRegistrationMutationError = AxiosError<HttpValidationProblemDetails | string>

    export const useUpdateFilterRegistration = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: FilterUnitRegistrationUpdateRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateFilterRegistration>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: FilterUnitRegistrationUpdateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateFilterRegistrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteFilterRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    filterUnitId: FilterUnitRegistrationId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.delete(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/filter-units/${encodeURIComponent(String(filterUnitId))}`,options
    );
  }



export const getDeleteFilterRegistrationMutationOptions = <TError = AxiosError<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFilterRegistration>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,filterUnitId} = props ?? {};

          return  deleteFilterRegistration(segmentationId,accountId,registrationCompositeId,filterUnitId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFilterRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFilterRegistration>>>
    
    export type DeleteFilterRegistrationMutationError = AxiosError<string>

    export const useDeleteFilterRegistration = <TError = AxiosError<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteFilterRegistration>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId},
        TContext
      > => {

      const mutationOptions = getDeleteFilterRegistrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const moveFilterRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    filterUnitId: FilterUnitRegistrationId,
    moveFilterUnitRequest: MoveFilterUnitRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/filter-units/${encodeURIComponent(String(filterUnitId))}/move`,
      moveFilterUnitRequest,options
    );
  }



export const getMoveFilterRegistrationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: MoveFilterUnitRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof moveFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: MoveFilterUnitRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveFilterRegistration>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: MoveFilterUnitRequest}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,filterUnitId,data} = props ?? {};

          return  moveFilterRegistration(segmentationId,accountId,registrationCompositeId,filterUnitId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MoveFilterRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof moveFilterRegistration>>>
    export type MoveFilterRegistrationMutationBody = MoveFilterUnitRequest
    export type MoveFilterRegistrationMutationError = AxiosError<HttpValidationProblemDetails | string>

    export const useMoveFilterRegistration = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: MoveFilterUnitRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof moveFilterRegistration>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;filterUnitId: FilterUnitRegistrationId;data: MoveFilterUnitRequest},
        TContext
      > => {

      const mutationOptions = getMoveFilterRegistrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    